<template>
    <div>
        <h5>Contato Seguro Canal de Ética</h5>
        <div style="display: flex; gap: 24px;">
            <div v-for="(media, idx) in medias" :key="idx" style="text-align: center;">
                <button @click="openModal(media)" style="background: none; border: none; cursor: pointer;">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="2" y="4" width="20" height="16" rx="2" ry="2"></rect>
                        <polygon points="10 9 16 12 10 15 10 9"></polygon>
                    </svg>
                </button>
                <!-- <div style="font-size: 0.9em; max-width: 120px; word-break: break-all;">{{ media.title }}</div> -->
                <div style="font-size: 0.9em; max-width: 120px;">{{ media.title }}</div>
            </div>
        </div>

        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-content">
                <video ref="videoPlayer" :src="currentMedia.url" controls style="max-width: 90vw; max-height: 80vh;" />
                <div style="margin-top: 8px; text-align: right;">
                    <button @click="toggleFullscreen" style="padding: 6px 12px; font-size: 1em;">Tela Cheia</button>
                    <button @click="closeModal" style="padding: 6px 12px; font-size: 1em; margin-left: 8px;">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template> 
<script>
export default {
    data() {
        return {
            medias: [                
                {
                    title: 'Assédio Moral',
                    url: 'http://portalbmwagulhasnegras.com.br/customers/agulhasnegras/ead/Contato%20Seguro_Treinamento%20EAD_Ass%C3%A9dio%20Moral.mp4',
                },
                {
                    title: 'Assédio Sexual',
                    url: 'http://portalbmwagulhasnegras.com.br/customers/agulhasnegras/ead/Contato%20Seguro_Treinamento%20EAD_Assedio%20Sexual.mp4',
                },
                {
                    title: 'Respeito à Diversidade',
                    url: 'http://portalbmwagulhasnegras.com.br/customers/agulhasnegras/ead/Contato%20Seguro_Treinamento%20EAD_Diversidade.mp4',
                },
                {
                    title: 'Combate à Discriminação',
                    url: 'http://portalbmwagulhasnegras.com.br/customers/agulhasnegras/ead/Contato%20Seguro_Treinamento%20EAD_Discrimina%C3%A7%C3%A3o.mp4',
                }
            ],
            showModal: false,
            currentMedia: null,
        };
    },
    methods: {
        openModal(media) {
            this.currentMedia = media;
            this.showModal = true;
            this.$nextTick(() => {
                const video = this.$refs.videoPlayer;
                if (video) video.pause();
            });
        },
        closeModal() {
            this.showModal = false;
            this.currentMedia = null;
        },
        toggleFullscreen() {
            const video = this.$refs.videoPlayer;
            if (video) {
                if (video.requestFullscreen) {
                    video.requestFullscreen();
                } else if (video.webkitRequestFullscreen) {
                    video.webkitRequestFullscreen();
                } else if (video.mozRequestFullScreen) {
                    video.mozRequestFullScreen();
                } else if (video.msRequestFullscreen) {
                    video.msRequestFullscreen();
                }
            }
        },
        getFileName(url) {
            try {
                return decodeURIComponent(url.split('/').pop());
            } catch {
                return url;
            }
        },
    },
};
</script>
<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.modal-content {
    background: #fff;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0 2px 16px rgba(0,0,0,0.2);
    max-width: 900px;
    width: 100%;
    text-align: center;
}
</style>